import React, { useEffect, useState } from "react";
import { PrescriptionModel } from "../../models";
import { DataTable } from "../../components";
import { PrescriptionInterface } from "../../interfaces";

const ViewPrescriptions = () => {
  const [prescriptions, setPrescriptions] = useState<PrescriptionInterface[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 15 });
  const [isLoading, setIsLoading] = useState(false);

  const fetchPrescriptions = async (pageIndex: number, pageSize: number) => {
    try {
      setIsLoading(true);
      const skip = pageIndex * pageSize;

      const resp = await PrescriptionModel.fetchAll<any>({
        $skip: skip,
        $limit: pageSize,
        $sort: { createdAt: -1 },
      });

      return {
        rows: resp.data,
        totalCount: resp.total,
      };
    } catch (error: any) {
      throw new Error(error.message);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    fetchPrescriptions(pagination.pageIndex, pagination.pageSize).then((res) => {
      setPrescriptions(res.rows);
      setTotalCount(res.totalCount);
    });
  }, [pagination]);

  return <DataTable 
    columns={PrescriptionModel.getColumns()} 
    data={prescriptions}  
    pagination={pagination}
    onPaginationChange={setPagination}
    totalRowCount={totalCount}
    loading={isLoading}
  />;
};

export default ViewPrescriptions;
